import { render, staticRenderFns } from "./LinkCellRenderer.vue?vue&type=template&id=349855d7&scoped=true&"
import script from "./LinkCellRenderer.vue?vue&type=script&lang=js&"
export * from "./LinkCellRenderer.vue?vue&type=script&lang=js&"
import style0 from "./LinkCellRenderer.vue?vue&type=style&index=0&id=349855d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349855d7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/components/ui/v-icon/VIcon.vue').default})
